import React from "react";
import { Provider } from "react-redux";
import { render } from "react-dom";
import configureStore from "state/configureStore";
import { handleImplicitRedirect } from "veritone-oauth-helpers";
// import JssProvider from "react-jss/lib/JssProvider";
import { JssProvider } from "react-jss";
import { create } from "jss";
import { createGenerateClassName, jssPreset } from "@material-ui/core/styles";
import validateAppConfig from "~helpers/validateAppConfig";
import './sentry';
import appConfig from "../config.json";
import "resources/styles/global.scss";
import App from "pages/App";

validateAppConfig();

function loadAiwareJS() {
    let aiwareJSPath = appConfig.aiwareJSPath;
    let aiwareJSVersion = appConfig.aiwareJSVersion;
    if (
      window.config &&
      window.config.aiwareJSPath &&
      window.config.aiwareJSVersion
    ) {
      //get config from data-center
      aiwareJSPath = window.config.aiwareJSPath.replace(/\/$/, '');
      aiwareJSVersion = window.config.aiwareJSVersion;
    }
    const aiwareJSScript = document.createElement('script');
    aiwareJSScript.setAttribute('type', 'module');
    const importStatement = document.createTextNode(`
      import {
        initAiwareJs, 
        mountAiwareWidget, 
        aiwareJsEventsOn,
        unmountAiwareWidget
      } from "${aiwareJSPath}${aiwareJSVersion}/index.esm.js";
      window.initAiwareJs = initAiwareJs;
      window.mountAiwareWidget = mountAiwareWidget;
      window.aiwareJsEventsOn = aiwareJsEventsOn;
      window.unmountAiwareWidget = unmountAiwareWidget;`);
    aiwareJSScript.appendChild(importStatement);
    document.head.appendChild(aiwareJSScript);
  }

function bootstrap() {
    if (window.name === "_auth") {
        // if this is an OAuth redirect window, deal with the OAuth response but
        // don't render the app.
        return handleImplicitRedirect(window.location.hash, window.opener);
    }
    const generateClassName = createGenerateClassName();
    const jss = create(jssPreset());
    // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
    jss.options.insertionPoint = "jss-insertion-point";

    const jssComment = document.createComment("jss-insertion-point");
    document.head &&
    document.head.insertBefore(jssComment, document.head.firstChild);
    const store = configureStore();
    render(
        <JssProvider jss={jss} generateClassName={generateClassName}>
            <Provider store={store}>
                <App />
            </Provider>
        </JssProvider>,
        document.getElementById("root")
    );
}

function registerServiceWorker() {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            const originUrl = window.location.origin;
            const serviceWorkerFileUrl = `${originUrl}/serviceWorker.js`;
            navigator.serviceWorker
                .register(serviceWorkerFileUrl)
                .then(registration => {
                    registration.onupdatefound = () => {
                        const installingWorker = registration.installing;
                        if (installingWorker === null) {
                            return;
                        }
                    };
                })
                .catch(error => {
                    console.error('Error during service worker registration:', error);
                });
        });
    }
}
loadAiwareJS();
bootstrap();
registerServiceWorker();
